import "./Podcast.module.css";
import Header from "@/reusable_sections/Header";
import PodcastOverview from "./sections/PodcastOverview";
import RecentEpisodes from "./sections/RecentEpisodes";
import YouTubeChannelPromotion from "./sections/YouTubeChannelPromotion";
import Footer from "@/reusable_sections/Footer";
export default function PodcastPage() {
  return <div>
      <Header />
      <PodcastOverview />
      <RecentEpisodes />
      <YouTubeChannelPromotion />
      <Footer />
    </div>;
}